module.exports = __webpack_public_path__ + "img/18.25fe0bff.jpg";